import { AppCatalogos } from '../utils/Constantes'

export interface PaginaState {
  nombrePagina: string
  filtros: Filtro[]
  ordenamiento: Ordenamiento
  pagina: number
  registrosPorPagina: number
}

export interface Filtro {
  /** Campo a filtrar (clave esperada por backend). */
  clave: string
  /** Valor del filtro (lista para selects multi o numero para rangos/paginacion). */
  valor: string[] | number
  /** Representacion para mostrar en UI (chips, resumen, etc.). */
  descripcion: string | number
  /** Etiqueta visible del filtro en UI. */
  etiqueta: string
  /** Tipo de control (text/select/fecha/etc.) segun componentes de filtros. */
  tipo?: string
  /** Claves auxiliares para rangos, cuando `isRango` es true. */
  rango?: string[]
  /** Indica si el filtro representa un rango (por ejemplo, fechas desde/hasta). */
  isRango?: boolean
}

export interface Ordenamiento {
  /** Nombre de columna/propiedad por la cual ordenar. */
  columna: string
  /** Direccion de orden (tipicamente ASC/DESC segun backend). */
  ordenar: string
}

export const PaginaVacia: PaginaState = {
  nombrePagina: '',
  filtros: [],
  ordenamiento: {
    columna: '',
    ordenar: '',
  },
  pagina: 1,
  registrosPorPagina: Number(AppCatalogos.CAT_REGISTROS_POR_PAGINA[0].valor),
}

export interface Reportes {
  idReporte: string
  idRelacionado: string
  tipo: string
  nombre: string
  ruta: File
}
